import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';
import firebase from 'firebase/app';
import 'firebase/auth';
import { FIREBASE_CONFIG } from './firebase.credentials';

@Injectable()
export class SmsAuthProvider {

	public recaptchaVerifier: firebase.auth.RecaptchaVerifier;

	constructor(private alertCtrl: AlertController) {
		firebase.initializeApp(FIREBASE_CONFIG);
	}

	refreshCaptcha() {
		this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
			'size': 'invisible',
		});
	}

	async isUserAutenticato() {
		return new Promise((resolve, reject) => {
			firebase.auth().onAuthStateChanged(user => resolve(user));
		});
	}

	getUser() {
		return firebase.auth().currentUser;
	}

	//Adapted from https://github.com/javebratt/firebase-phone-authentication
	smsLogin(phoneNumber: number): Promise<any> {
		return new Promise(async (resolve, reject) => {

			const user = await this.isUserAutenticato();
			if(user) {
				resolve(user);
				return;
			}
			// if (this.isUserAutenticato()) {
			// 	resolve(firebase.auth().currentUser);
			// 	return;
			// }
			const appVerifier = this.recaptchaVerifier;
			const phoneNumberString = "+39" + phoneNumber;
			//Signin with phonenumbers requires BOTH the phone number and a verified captcha
			firebase.auth().signInWithPhoneNumber(phoneNumberString, appVerifier)
				.then(confirmationResult => {
					// SMS sent. Prompt user to type the code from the message, then sign the
					// user in with confirmationResult.confirm(code).
					let prompt = this.alertCtrl.create({
						title: 'Codice SMS',
						inputs: [{ name: 'confirmationCode', placeholder: 'Inserisci il codice ricevuto' }],
						buttons: [
							{
								text: 'Annulla',
								handler: data => {
									// console.log('Cancel clicked');
								}
							},
							{
								text: 'Invia',
								handler: data => {
									confirmationResult.confirm(data.confirmationCode)
										.then(function (result) {
											// User signed in successfully.
											resolve(result.user);
											// console.log(firebase.auth().currentUser);
											//Pop back to the previous page.
											// this.navCtrl.pop();
										}).catch(function (error) {
											// User couldn't sign in (bad verification code?)
											// ...
										});
								}
							}
						]
					});
					prompt.present();
				})
				.catch(function (error) {
					console.error("SMS not sent", error);
				});
		
		});
	}

	logout(): Promise<any> {
		return firebase.auth().signOut();
	}

}



// WEBPACK FOOTER //
// ./src/providers/sms-auth/sms-auth.ts